module.exports = __webpack_public_path__ + "static/media/play-button.75be2c69.svg";